import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import './AppDropdownButton.css';

export interface AppDropdownButtonOption {
	label: string;
	onClick: () => void;
	disabled?: boolean;
}

export interface AppDropdownButtonProps {
	label: string;
	options: AppDropdownButtonOption[];
	className?: string;
	buttonClassName?: string;
	menuClassName?: string;
}

export default function AppDropdownButton ({
	label,
	options,
	className = "",
	buttonClassName = "",
	menuClassName = "",
}: AppDropdownButtonProps) {
	const [open, setOpen] = useState<boolean>(false);
	const dropdownRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent): void => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleOptionClick = (option: AppDropdownButtonOption): void => {
		if (option.disabled) return;

		setOpen(false);
		option.onClick();
	};

	return (
		<div className={`dropdown-buttons-container ${className}`} ref={dropdownRef}>
			<Button
				variant="secondary"
				className={buttonClassName}
				onClick={() => setOpen((prev) => !prev)}
			>
				{label}
			</Button>

			{open && (
				<div className={`dropdown-buttons-menu ${menuClassName}`}>
					{options.map((option, index) => (
						<Button
							variant="light"
							key={`${option.label}-${index}`}
							disabled={option.disabled}
							onClick={() => handleOptionClick(option)}
						>
							{option.label}
						</Button>
					))}
				</div>
			)}
		</div>
	);
};